import { Routes, Route } from "react-router-dom";

//import commercial pages
import LandingPage from "./view/pages/landing-page/LandingPage.jsx";

//import app pages
import Authentication from "./view/pages/authentication/Authentication.jsx";
import ProjectDashboardPage from "./view/pages/project-dashboard/ProjectDashboardPage.jsx";
import TaskDashboardPage from "./view/pages/task-dashboard/TaskDashboardPage.jsx";
import TemplateDashboardPage from "./view/pages/template-dashboard/TemplateDashboardPage.jsx";
import Settings from "./view/pages/settings/Settings.jsx";
import Billing from "./view/pages/billing/Billing.jsx";
// import About from "./view/pages/about/About.jsx";
import Features from "./view/pages/features/Features.jsx";
import UseCases from "./view/pages/use-cases/UseCases.jsx";
// import Pricing from "./view/pages/pricing/Pricing.jsx";

import "./App.css";

const App = () => {
  //make the pages for the app

  //use routes to orgaize nested components
  //use react context providers to sync data throughout app with single state container

  return (
    <Routes path="/">
      {/* Application Pages */}
      <Route index element={<LandingPage />} />

      <Route path="/auth/*" element={<Authentication />} />
      <Route path="/project-dashboard/*" element={<ProjectDashboardPage />} />
      <Route path="/task-dashboard/*" element={<TaskDashboardPage />} />
      <Route path="/template-dashboard/*" element={<TemplateDashboardPage />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/billing" element={<Billing />} />

      {/* <Route path="/use-cases/*" element={<UseCases />} /> */}

      {/* Public SEO / Marketing pages */}
      {/* <Route path="/features" element={<Features />} /> */}

      {/*
        insert NavBar as the consistent component, keep everythnig operating as a page. remove navbar from pages**
       <Route index element={<Authentication />} />
      <Route path="/auth/*" element={<Authentication />} />
      <Route path="/projects" element={<ProjectList />} />
      <Route path="/projects/:projectID" element={<TaskList />} />

      <Route path="/about" element={<About />} />
      <Route path="/features" element={<Features />} />
      <Route path="/pricing" element={<Pricing />} /> */}
    </Routes>
  );
};

export default App;

//<ProjectList />
//<TaskList />
